var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, action, makeObservable } from 'mobx';
import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { xa } from '../../../../utils/xa/xa';
export class MiniQuestionPassState {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get miniQuestion() {
        return this.parent;
    }
    get app() {
        return this.miniQuestion.app;
    }
    get questionState() {
        return this.questionStateFromMicro || QuestionPassStateId.New;
    }
    setQuestionState(reason, timestamp = new Date().mysqlTimestamp) {
        this.questionStateEntry.state = reason;
        xa.personalTopic.setQuestionState({
            reason,
            timestamp: new Date().mysqlTimestamp,
            questionId: this.miniQuestion.id,
        });
    }
    get questionStateEntry() {
        return this.miniQuestion.topic.topicFilter.filterQuestionQuery.streamedDeep.find(row => row.qid === this.miniQuestion.id);
    }
    get questionStateFromMicro() {
        if (this.questionStateEntry)
            return this.questionStateEntry.state;
        return undefined;
    }
}
__decorate([
    action.bound
], MiniQuestionPassState.prototype, "setQuestionState", null);
__decorate([
    computed
], MiniQuestionPassState.prototype, "questionStateEntry", null);
